<!-- Authored.by.KWShin.2024.03.28. -->
<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    sstmId: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('common/system', ['getSystemById']),
    dbType() {
      return this.getSystemById(this.sstmId).database.type;
    },
    title() {
      return this.dbType == 'HANA' ? this.$t('dv.title.db.memory') : this.$t('dv.title.db.tblspace');
    },
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  data() {
    return {
      data: {
        value: '',
        type: 'percent',
      },
    };
  },
  methods: {
    setData(dataList) {
      if (this.dbType == 'HANA') {
        let totMem = 0;
        let totUsed = 0;
        dataList.forEach(data => {
          totMem += data.physMemTotal ? parseInt(data.physMemTotal) : 0;
          totUsed += data.physMemUsed ? parseInt(data.physMemUsed) : 0;
        });
        this.data.value = totMem == 0 ? 0 : Math.ceil((totUsed / totMem) * 100);
      } else {
        let totMem = 0;
        let totFree = 0;
        dataList.forEach(data => {
          totMem += data.tsize ? parseInt(data.tsize) : 0;
          totFree += data.tfree ? parseInt(data.tfree) : 0;
        });
        this.data.value = totMem == 0 ? 0 : Math.ceil(((totMem - totFree) / totMem) * 100);
      }
    },
  },
};
</script>
